import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/normalAction";
import * as uiHelpers from "../NormalUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useDistributionNormalUIContext } from "../NormalUIContext";
import { BlockOrg, RoleChecker } from "../../../../../RoleChecker";

const DistributionNormalTable = ({
  distributionData = {},
  setDistributionData,
  onSubmit,
}) => {
  // DistributionNormal UI Context
  const distributionNormalUIContext = useDistributionNormalUIContext();
  const distributionNormalUIProps = useMemo(() => {
    return {
      queryParams: distributionNormalUIContext.queryParams,
      setQueryParams: distributionNormalUIContext.setQueryParams,
      newDistributionNormalIndividuButtonClick:
        distributionNormalUIContext.newDistributionNormalIndividuButtonClick,
      openDeleteDistributionNormalPage:
        distributionNormalUIContext.openDeleteDistributionNormalPage,
      openEditDistributionNormalIndividualPage:
        distributionNormalUIContext.openEditDistributionNormalIndividualPage,
      openEditDistributionNormalOrganizationPage:
        distributionNormalUIContext.openEditDistributionNormalOrganizationPage,
    };
  }, [distributionNormalUIContext]);

  // Getting curret state of distributionNormal list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.distributionNormal }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  // Table columns
  const columns = [
    {
      dataField: "donation.donation_hid",
      text: "ID Donasi",
    },
    {
      dataField: "donation.donor.name",
      text: "Donatur",
    },
    {
      dataField: "name_1",
      text: "Atas Nama",
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: distributionNormalUIProps.queryParams.pageSize,
    page: distributionNormalUIProps.queryParams.pageNumber,
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        setDistributionData((prev) => {
          const temp = [...prev.donation_item_uuids];
          temp.push(row.uuid);
          return {
            ...prev,
            donation_item_uuids: temp,
          };
        });
      } else {
        setDistributionData((prev) => {
          const temp = [...prev.donation_item_uuids];
          const newArray = temp.filter((uuid) => uuid != row.uuid);
          return {
            ...prev,
            donation_item_uuids: newArray,
          };
        });
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        setDistributionData((prev) => {
          const newArray = [];
          rows.forEach((item) => {
            newArray.push(item.uuid);
          });
          return {
            ...prev,
            donation_item_uuids: newArray,
          };
        });
      } else {
        setDistributionData((prev) => ({
          ...prev,
          donation_item_uuids: [],
        }));
      }
    },
  };

  return (
    <>
      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        remote
        keyField="uuid"
        data={entities === null ? [] : entities}
        columns={columns}
        selectRow={selectRow}
      >
        <PleaseWaitMessage entities={entities} />
        <NoRecordsFoundMessage entities={entities} />
      </BootstrapTable>

      {RoleChecker("Update", "distribution") && entities.length > 0 && (
        <div>
          <button
            className="btn btn-primary float-right"
            onClick={onSubmit}
            disabled={distributionData.donation_item_uuids.length <= 0}
          >
            Distribusikan
          </button>
        </div>
      )}
    </>
  );
};

export default DistributionNormalTable;
